import { createRoot, createSignal } from "solid-js"

export const [getColor, setColor] = createRoot(() => {
  // eslint-disable-next-line solid/reactivity
  return createSignal<string>("#ffffff")
})

// Helper functions for color conversion
export const numberToHex = (color: number): string => {
  return `#${color.toString(16).padStart(6, '0')}`
}

export const hexToNumber = (hex: string): number => {
  return parseInt(hex.substring(1), 16)
}
